/**
 * @generated SignedSource<<2d61264a0024f3bca8dc2a84ba209336>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SalesforceConfigurationConductor_Query$variables = {};
export type SalesforceConfigurationConductor_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SalesforceConfigurationConductor_viewer">;
  } | null;
};
export type SalesforceConfigurationConductor_Query = {
  variables: SalesforceConfigurationConductor_Query$variables;
  response: SalesforceConfigurationConductor_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "salesforce_configuration_conductor"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"salesforce_configuration_conductor\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforceConfigurationConductor_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SalesforceConfigurationConductor_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SalesforceConfigurationConductor_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newSalesforceEnabled",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "52f38e2bd2f2b45d0a8aa1feca0116e5",
    "id": null,
    "metadata": {},
    "name": "SalesforceConfigurationConductor_Query",
    "operationKind": "query",
    "text": "query SalesforceConfigurationConductor_Query {\n  viewer {\n    actualPersonId\n    component(name: \"salesforce_configuration_conductor\")\n    ...SalesforceConfigurationConductor_viewer\n    id\n  }\n}\n\nfragment SalesforceConfigurationConductor_viewer on Viewer {\n  company {\n    newSalesforceEnabled\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a7ec06a9f7f6df4887082f7adf035c8";

export default node;
